import { get, post } from './request'

export let paginate = (path, success, failure) => {
  return get(
    `api${path}`, success, failure
  )
}

export let load = (navItem, success, failure) => get(
  `api/site/navigation/${navItem}`, success, failure
)

export let create = (navItem, parent, success, failure) => post(
  `api/site/navigation/${parent}`, navItem, success, failure
)

export let save = (navItem, success, failure) => post(
  `api/site/navigation/${navItem.id}/update`, navItem, success, failure
)

export let remove = (navItem, success, failure) => post(
  `api/site/navigation/${navItem}/remove`, {}, success, failure
)
